import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';

export const TERMINOLOGY_LANGUAGES = ['de', 'en', 'cs', 'es'];
export const TERMINOLOGY_KEYS = ['agent_singular', 'agent_plural', 'agent_admin_area', 'instruction_singular', 'instruction_plural', 'request_singular', 'request_plural'];

export const fetchTerminology = createAsyncThunk('terminology/fetch', async () => {
  const response = await axios.get(`${BASE_URL}/terminology`, authHeaders());
  return response.data.terms || {};
});

export const fetchOrgTerminology = createAsyncThunk('terminology/fetchOrg', async (orgId, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${BASE_URL}/organizations/${encodeURIComponent(orgId)}/terminology`, authHeaders());
    return response.data.terms || {};
  } catch (err) {
    return rejectWithValue(err.response?.status || 0);
  }
});

export const saveOrgTerminology = createAsyncThunk('terminology/saveOrg', async ({ orgId, terms }, { rejectWithValue }) => {
  try {
    const response = await axios.put(`${BASE_URL}/organizations/${encodeURIComponent(orgId)}/terminology`, { terms }, authHeaders());
    return response.data.terms || {};
  } catch (err) {
    return rejectWithValue(err.response?.status || 0);
  }
});

const terminologySlice = createSlice({
  name: 'terminology',
  initialState: { terms: {}, status: 'idle', loaded: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTerminology.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTerminology.fulfilled, (state, action) => {
        state.status = 'done';
        state.loaded = true;
        if (JSON.stringify(state.terms) !== JSON.stringify(action.payload)) state.terms = action.payload;
      })
      .addCase(fetchTerminology.rejected, (state) => {
        state.status = 'done';
        state.loaded = true;
      });
  },
});

export default terminologySlice.reducer;
